<template>
  <section v-if="product && !isComingSoon" class="my-4 ">
    <h2 v-if="showHeading" class="mb-2 text-sm fw-bold" data-test-id="size-fit-model-header">
      {{ $t.sizeAndFit }}
    </h2>
    <div
      v-if="$feature.showModelMeasurementsOnPDP
        && (showModelMeasurements && modelMeasurements?.length)"
      class="mb-4"
      data-test-id="size-fit-model"
    >
      <p
        v-for="(modelMeasurement, i) in modelMeasurements"
        :key="i"
        class="text-xs "
                data-test-id="size-fit-model-content"
      >
        {{ modelMeasurement }}
      </p>
    </div>
    <div
      v-if="$feature.showFitRatingOnPDP
        && (showFitRating && reviewsData?.paging.totalResults && fitRating?.display_values)"
      class="mb-4 b b-grey-50 p-4 space-y-2 "
    >
      <p id="size-fit-rating" class="text-xs ">
        {{ $t.fitBasedOn }}
        <base-link
          class="underlined"
          :to="{
            hash: '#reviews',
            query: route.query,
            state: history.state,
          }"
          @click="$gtm.push('pdpPage.onViewReviews')"
        >
          {{
            replaceAll(
              $pluralize($t.numberOfReviews, reviewsData?.rollup?.reviewCount!),
              { reviewsCount: reviewsData?.rollup?.reviewCount },
            )
          }}
        </base-link>
      </p>
      <vf-meter
        aria-labelledby="size-fit-rating"
        :aria-valuetext="getFitRatingValues(fitRating).label"
        :max-label="fitRating.display_values[fitRating.display_values.length - 1]"
        :max-value="fitRating.display_values.length"
        :min-label="fitRating.display_values[0]"
        :value="getFitRatingValues(fitRating).value"
      />
    </div>
    <div
      v-if="$feature.showSizeChartButtonOnPDP
        && (product.sizeChart || $feature.showFitFinderOnPDP || product.fitSize)"
      class="flex text-sm underlined between"
    >
      <span v-if="product.sizeChart" class="flex gap-1">
        <vf-icon v-if="showSizeChartIcon" name="size" size="md" />
        <base-button id="pdp-size-chart"  @click="openSizeGuide">
          {{ $t.sizeChart }}
        </base-button>
      </span>
      <div v-if="$feature.showFitFinderOnPDP" id="fit-finder-container" />
      <base-button v-else-if="product.fitSize" >
        {{ $t.findYourSize }}
      </base-button>
    </div>
  </section>
</template>

<script setup lang="ts">
const { showFitRating, showHeading, showModelMeasurements, showSizeChartIcon } = useAppConfig().pages.pdp.sizeAndFit
const { fitRating, isComingSoon, openSizeGuide, product, reviewsData } = usePdp()
const route = useRoute()
const { history } = useRouter().options

const hasDivider = computed(() => product.value?.modelMeasurements?.[0]?.includes('|'))

const modelMeasurements = computed(() => {
  const measurements = product.value?.modelMeasurements
  if (measurements?.length && hasDivider)
    return [...measurements[0].split('|'), ...measurements.slice(1)]

  return measurements
})
</script>
